import React from "react";


import publicUrls from "../../../routes/publicUrls";
import Section from "../../../components/gallery/Section";
import SectionHeader from "../../../components/gallery/SectionHeader";
import CardRail from "../../../components/gallery/CardRail";
import { EventCard } from "../../../components/gallery/Cards";
import { formatLongDate } from "../utils";



const exhibitionUrl = (ex) => publicUrls.exhibition(ex.c_slug, ex.id);
const exhibitionTitle = (ex) => ex.d_name || ex.d_desc || "";

function dateRange(ex) {
  const start = formatLongDate(ex.date_start);
  const end = formatLongDate(ex.date_end);
  if (start && end && start !== end) return `${start} – ${end}`;
  return start || end;
}

export function CurrentExhibitions({ exhibitions }) {
  if (!exhibitions || exhibitions.length === 0) return null;

  return (
    <Section labelledBy="home-exhibitions-title">
      <SectionHeader
        id="home-exhibitions-title"
        eyebrow="Exhibitions"
        title="On view now"
        actionLabel="All exhibitions"
        actionHref={publicUrls.exhibitions()}
      />
      <CardRail label="exhibitions" perView={{ sm: 2, md: 3, lg: 3 }} mobileWidth="44%">
        {exhibitions.map((ex) => (
          <EventCard
            key={ex.id}
            href={exhibitionUrl(ex)}
            image={ex.cover}
            imageAlt={`${exhibitionTitle(ex)} — exhibition image`}
            eyebrow="Exhibition"
            title={exhibitionTitle(ex)}
            meta={dateRange(ex)}
            compact
          />
        ))}
      </CardRail>
    </Section>
  );
}
